function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import { getSessionStorage } from "./sessionStorage";

/**
 * PAGE_SIZE 表格分页SIZE
 * SID 站点id
 * SITE_STORE 站点信息
 * USER_STORE 用户信息
 */
var KEYS = /*#__PURE__*/function (KEYS) {
  KEYS["SID"] = "sid";
  KEYS["USER_STORE"] = "workUserStore";
  KEYS["SITE_STORE"] = "workSiteStore";
  return KEYS;
}(KEYS || {});
export var KEY_OF_STORE_MAP = {
  portal: {
    SITE_STORE: 'gatewaySiteStore',
    USER_STORE: 'gatewayUserStore'
  },
  workbench: {
    SITE_STORE: 'workSiteStore',
    USER_STORE: 'workUserStore'
  },
  middle: {
    SITE_STORE: 'middleSiteStore',
    USER_STORE: 'middleUserStore'
  }
};
var getMatchKey = function getMatchKey(key) {
  var platform = getSessionStorage('PLATFORM');
  var finalKey = 'workSiteStore';
  if (key === 'SITE_STORE' || key === 'USER_STORE') {
    return KEY_OF_STORE_MAP[platform][key];
  }
  return finalKey;
};

/**
 * 获取 localStorage
 * @param key
 * @returns
 */
export var getLocalStorage = function getLocalStorage(key) {
  if (typeof window === 'undefined') return;
  var res = null;
  var finalKey = 'workSiteStore';
  if (key === 'SITE_STORE' || key === 'USER_STORE') {
    finalKey = getMatchKey(key);
    res = localStorage.getItem(finalKey);
  } else {
    finalKey = KEYS[key];
    res = localStorage.getItem(finalKey);
  }
  try {
    return JSON.parse(res);
  } catch (e) {
    return res;
  }
};

/**
 * 通用写入 localStorage
 * @param key
 * @param val
 */
export var setLocalStorage = function setLocalStorage(key, val) {
  if (typeof window === 'undefined') return;
  localStorage.setItem(KEYS[key], _typeof(val) === 'object' ? JSON.stringify(val) : val);
};

/**
 * 删除
 * @param key
 */
export var delLocalStorage = function delLocalStorage(key) {
  if (!window) return;
  localStorage.removeItem(key);
};